export enum BookingFreeBusy {
	Free,
	Busy,
	CheckinRequired,
	BlockingTime,
}
